// extracted by mini-css-extract-plugin
export default {"personalContainer":"styles_personalContainer__JOV3m","picture":"styles_picture__Wg4rx","description":"styles_description__vf1NQ"};